// extracted by mini-css-extract-plugin
module.exports = {"layoutContain":"layout-module--layoutContain--3ElY7","footer":"layout-module--footer--1q4Vo","homeLayout":"layout-module--homeLayout--3D046"};